import React, { useState } from 'react';
import { Input, Button, Modal, Spin, Radio, Checkbox } from 'antd';
import LookupField from '../../components/LookupField';
import { useDeptForm } from './hooks/useDeptForm';

const P1106Form: React.FC = () => {
  const {
    mode, isEditing, loading, records, current, currentIdx,
    code, setCode, name, setName, unitType, setUnitType,
    mgrCode, setMgrCode, mgrName, vpCode, setVpCode, vpName,
    shortCode, setShortCode, isOld, setIsOld, level, setLevel,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, cancel, save, doDelete, quickSearch,
    lookupManager, lookupVP,
  } = useDeptForm();

  const [searchText, setSearchText] = useState('');

  const handleDelete = () => {
    if (!current) return;
    Modal.confirm({
      title: '確認刪除',
      content: `確定要刪除部門「${current.f106_01}」（${current.f106_11}）？`,
      okText: '刪除', okType: 'danger', cancelText: '取消',
      onOk: doDelete,
    });
  };

  const handleQuickSearch = () => { if (searchText.trim()) quickSearch(searchText.trim()); };
  const modeLabel = mode === 'add' ? '新增' : mode === 'edit' ? '修改' : '瀏覽';

  return (
    <Spin spinning={loading}>
      <div className="max-w-2xl mx-auto p-6">
        <h2 className="text-xl font-bold mb-4">
          部門建檔 (pw1106f1)
          <span className="ml-3 text-sm font-normal text-gray-500">
            [{modeLabel}] {records.length > 0 ? `${currentIdx + 1} / ${records.length}` : '無資料'}
          </span>
        </h2>

        <div className="flex items-center gap-2 mb-4">
          <Input placeholder="輸入部門代號查詢" value={searchText} onChange={e => setSearchText(e.target.value)}
            onPressEnter={handleQuickSearch} disabled={isEditing} style={{ width: 200 }} maxLength={4} />
          <Button onClick={handleQuickSearch} disabled={isEditing}>查詢</Button>
        </div>

        <div className="flex items-center gap-1 mb-4">
          <Button size="small" onClick={navFirst} disabled={isEditing || records.length === 0}>|&lt;</Button>
          <Button size="small" onClick={navPrev} disabled={isEditing || currentIdx <= 0}>&lt;</Button>
          <Button size="small" onClick={navNext} disabled={isEditing || currentIdx >= records.length - 1}>&gt;</Button>
          <Button size="small" onClick={navLast} disabled={isEditing || records.length === 0}>&gt;|</Button>
        </div>

        <div className="space-y-3 mb-6">
          <div className="flex items-center gap-4">
            <label className="w-24 text-sm text-right">部門代號</label>
            <Input value={code} onChange={e => setCode(e.target.value)} maxLength={4}
              disabled={mode !== 'add'} style={{ width: 120 }} placeholder="4碼" />
          </div>
          <div className="flex items-center gap-4">
            <label className="w-24 text-sm text-right">部門等級</label>
            <Input value={level} onChange={e => setLevel(e.target.value)} maxLength={4}
              disabled={!isEditing} style={{ width: 120 }} />
          </div>
          <div className="flex items-center gap-4">
            <label className="w-24 text-sm text-right">部門名稱</label>
            <Input value={name} onChange={e => setName(e.target.value)} maxLength={40}
              disabled={!isEditing} style={{ width: 300 }} />
          </div>
          <div className="flex items-center gap-4">
            <label className="w-24 text-sm text-right">單位類別</label>
            <Radio.Group value={unitType} onChange={e => setUnitType(e.target.value)} disabled={!isEditing}>
              <Radio value={1}>事業單位</Radio>
              <Radio value={2}>幕僚單位</Radio>
            </Radio.Group>
          </div>
          <div className="flex items-center gap-4">
            <label className="w-24 text-sm text-right">部門主管</label>
            <LookupField lookupType="employee" value={mgrCode} maxLength={8}
              disabled={!isEditing} style={{ width: 120 }}
              onChange={setMgrCode}
              onCodeConfirm={(code) => lookupManager(code)} />
            <span className="text-sm text-gray-500">{mgrName}</span>
          </div>
          <div className="flex items-center gap-4">
            <label className="w-24 text-sm text-right">管轄副總</label>
            <LookupField lookupType="employee" value={vpCode} maxLength={8}
              disabled={!isEditing} style={{ width: 120 }}
              onChange={setVpCode}
              onCodeConfirm={(code) => lookupVP(code)} />
            <span className="text-sm text-gray-500">{vpName}</span>
          </div>
          <div className="flex items-center gap-4">
            <label className="w-24 text-sm text-right">簡碼</label>
            <Input value={shortCode} onChange={e => setShortCode(e.target.value)} maxLength={1}
              disabled={!isEditing} style={{ width: 60 }} />
          </div>
          <div className="flex items-center gap-4">
            <label className="w-24 text-sm text-right">舊代號</label>
            <Checkbox checked={isOld} onChange={e => setIsOld(e.target.checked)} disabled={!isEditing} />
          </div>
        </div>

        {current && mode === 'browse' && (
          <div className="text-xs text-gray-400 mb-6">
            修改人員: {current.f106_91} | 修改日期: {current.f106_92 || '-'} | 修改時間: {current.f106_93}
          </div>
        )}

        <div className="flex items-center gap-2">
          {!isEditing ? (
            <>
              <Button type="primary" onClick={startAdd}>新增</Button>
              <Button onClick={startEdit} disabled={!current}>修改</Button>
              <Button danger onClick={handleDelete} disabled={!current}>刪除</Button>
            </>
          ) : (
            <>
              <Button type="primary" onClick={save}>儲存</Button>
              <Button onClick={cancel}>取消</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default P1106Form;
